<template>
  <Head>
    <Link
      rel="icon"
      type="image/x-icon"
      href="/favicon.png" />
  </Head>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
  import '~/assets/styles/main.css'

  import { onMounted } from 'vue'
  import { useNuxtApp } from '#imports'

  import useTrackScrollDepth from '~~/composables/track-scroll-depth'

  const { $plausible } = useNuxtApp()
  useTrackScrollDepth()

  onMounted(() => {
    $plausible()
  })
</script>
